export default __webpack_public_path__ + "7779cc2c92ee85cfd8f53da69c27206e.png";